import { useState } from 'react';
import './Card.scss';
import clsx from 'clsx';
import ChevronIcon from 'components/sidebar/icons/chevron-icon';
import { AgxTypography } from '@urbanx/agx.ui-components2';

const Card = ({
  title,
  children,
  collapsible = true,
}: {
  title: string;
  children: React.ReactNode;
  collapsible?: boolean;
}) => {
  const [collapsed, setCollapsed] = useState(false);

  const handleHeaderClick = () => {
    if (collapsible) {
      setCollapsed(!collapsed);
    }
  };

  return (
    <div className={clsx('card', collapsible && collapsed && 'collapsed')}>
      <div className={'card-header'} onClick={handleHeaderClick}>
        <AgxTypography id="card-title" type="title" size="large">
          {title}
        </AgxTypography>
        {collapsible && <ChevronIcon />}
      </div>
      {(!collapsed || !collapsible) && <div className="card-content">{children}</div>}
    </div>
  );
};

export default Card;
